// src/components/common/PublicLayout.js
import React from 'react';
import { Box } from '@mui/material';
import Footer from '../Footer/Footer';

const PublicLayout = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                pb: 0
            }}
        >
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
};

export default PublicLayout;